import Checkbox from "@/components/LandingCheckboxes/Checkbox";
import React from "react";

export default function Step1({
  questionsBlocks,
  answer,
  setAnswer,
  type,
}: any) {
  return (
    <>
      {questionsBlocks.map((question: any) => (
        <>
          <div className="p-4" key={question._uid}>
            <p className="text-main-black mb-8 md:text-left text-center">
              {question.title}
            </p>
            <div className="flex gap-4">
              {question.answers.map((i: string) => (
                <Checkbox
                  key={question._uid}
                  label={i}
                  id={question._uid}
                  name={question.title}
                  answer={answer}
                  setAnswer={setAnswer}
                  type={type}
                />
              ))}
            </div>
          </div>
          <div className="hor-line"></div>
        </>
      ))}
    </>
  );
}
